import { IconAbout, IconContact, IconExperience, IconProjects, IconResearch } from './desktop';
import {
  IconGames,
  IconMines,
  IconCards,
  IconSnake,
  IconBlocks,
  IconBricks,
  IconPaddle,
  IconInvaders,
} from './games';

export { IconAbout, IconExperience, IconProjects, IconResearch, IconContact } from './desktop';
export {
  IconGames,
  IconMines,
  IconCards,
  IconSnake,
  IconBlocks,
  IconBricks,
  IconPaddle,
  IconInvaders,
} from './games';
export { GlyphApp, GlyphClose, GlyphMenu } from './glyphs';

// Lookup by name: the desktop and game icons.
export const ICONS = {
  IconAbout,
  IconExperience,
  IconProjects,
  IconResearch,
  IconContact,
  IconGames,
  IconMines,
  IconCards,
  IconSnake,
  IconBlocks,
  IconBricks,
  IconPaddle,
  IconInvaders,
};
